const $8f6a480bb40b134f$var$playSoundAnchor = document.getElementById('playStrichSoundAnchor');
var $09312dd88ac533fa$exports = {};
$09312dd88ac533fa$exports = import.meta.resolve("5acYR");


if ($8f6a480bb40b134f$var$playSoundAnchor) {
    // See: https://parceljs.org/getting-started/migration/#importing-non-code-assets-from-javascript
    const soundUrl = new URL($09312dd88ac533fa$exports);
    $8f6a480bb40b134f$var$playSoundAnchor.addEventListener('click', function(evt) {
        new Audio(soundUrl).play();
        evt.preventDefault();
    });
}


//# sourceMappingURL=strich-landing-page.c4713bed.js.map
